<script setup>

import {ref, computed, onMounted, defineModel, watchEffect} from "vue";
import {useRoute} from "vue-router";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import {Api} from "@/service/api";
import ToggleSwitch from "@/components/UI/ToggleSwitch.vue";

const isVisible = defineModel()


const route = useRoute();

const hours = ref([
    "00:00",
    "01:00",
    "02:00",
    "03:00",
    "04:00",
    "05:00",
    "06:00",
    "07:00",
    "08:00",
    "09:00",
    "10:00",
    "11:00",
    "12:00",
    "13:00",
    "14:00",
    "15:00",
    "16:00",
    "17:00",
    "18:00",
    "19:00",
    "20:00",
    "21:00",
    "22:00",
    "23:00",
])

const rangeHours = ref([])

const ranges = ref([]) // Автозаполнение в onMounted
const days = ref([
    {
        value: "MONDAY",
        name: "Понедельник"
    },
    {
        value: "TUESDAY",
        name: "Вторник"
    },
    {
        value: "WEDNESDAY",
        name: "Среда"
    },
    {
        value: "THURSDAY",
        name: "Четверг"
    },
    {
        value: "FRIDAY",
        name: "Пятница"
    },
    {
        value: "SATURDAY",
        name: "Суббота"
    },
    {
        value: "SUNDAY",
        name: "Воскресенье"
    },

])
const offsets = ref([
    {
        value: 1,
        name: "Каждый час"
    },
    {
        value: 2,
        name: "Каждые 2 часа"
    },
    {
        value: 4,
        name: "Каждые 4 часа"
    },
    {
        value: 8,
        name: "Каждые 8 часов"
    },
    {
        value: 12,
        name: "Каждые 12 часов"
    },
])

const frequencySettings = ref([
    {
        name: "Несколько раз в день",
        value: "MULTIPLY_TIMES_A_DAY"
    },
    {
        name: "Раз в в день",
        value: "ONCE_A_DAY"
    },
])

const settings = ref({})
const isEnabled = ref(false)
const selectedDays = ref([])
const selectedFrequency = ref("")
const selectedTimeRange = ref([])
const selectedTimeStart = ref("")
const selectedOffset = ref(1)
const isLoading = ref(false)


watchEffect(() => {
    rangeHours.value = []
    hours.value.forEach((hour, index) => {
        if (index % selectedOffset.value === 0) {
            rangeHours.value.push(hour)
        }
    })
    const indexHoursLeft = hours.value.indexOf(selectedTimeRange.value[0])
    const indexHoursRight = hours.value.indexOf(selectedTimeRange.value[1])
    const indexRangeHoursLeft = hours.value.indexOf(rangeHours.value[0])
    const indexRangeHoursRight = hours.value.indexOf(rangeHours.value[rangeHours.value.length - 1])

    if (indexHoursLeft < indexRangeHoursLeft) {
        selectedTimeRange.value[0] = rangeHours.value[0]
    }
    if (indexHoursRight > indexRangeHoursRight) {
        selectedTimeRange.value[1] = rangeHours.value[rangeHours.value.length - 1]
    }
    if (indexHoursLeft % selectedOffset.value !== 0) {
        selectedTimeRange.value[0] = hours.value[Math.floor(indexHoursLeft / selectedOffset.value) * selectedOffset.value]
    }
    if (indexHoursRight % selectedOffset.value !== 0) {
        selectedTimeRange.value[1] = hours.value[Math.floor(indexHoursRight / selectedOffset.value) * selectedOffset.value]
    }
})


const transactionsPerLoad = ref(1)


onMounted(async () => {
    for (let i = 0; i < hours.value.length; i++) {
        if (i !== hours.value.length - 1) {
            ranges.value.push({
                time_range_start: hours.value[i],
                time_range_end: hours.value[i + 1]
            })
        }
        else {
            ranges.value.push({
                time_range_start: hours.value[i],
                time_range_end: hours.value[0]
            })
        }
    }

    const workflow_id = route.params.workflow_id
    settings.value = await Api.getWorkflowSettings(workflow_id)

    isEnabled.value = settings.value.is_trigger_start_enabled
    selectedDays.value = settings.value.days
    selectedFrequency.value = settings.value.start_frequency
    selectedTimeRange.value[0] = hours.value[6]
    selectedTimeRange.value[1] = hours.value[18]
    selectedTimeStart.value = hours.value[15]

    if (selectedFrequency.value === "MULTIPLY_TIMES_A_DAY") {
        selectedTimeRange.value[0] = settings.value.frequency.time_range_start
        selectedTimeRange.value[1] = settings.value.frequency.time_range_end
        selectedOffset.value = settings.value.frequency.offset
    }
    else if (selectedFrequency.value === "ONCE_A_DAY") {
        selectedTimeStart.value = settings.value.frequency.time_start
    }

    transactionsPerLoad.value = settings.value.transactions_per_load
})

const transactionsPerMonth = computed(() => {return 1})


function isDaySelected(day) {
    return selectedDays.value.find((value) => value === day.value) !== undefined
}

function toggleDay(day) {
    if (isDaySelected(day)) {
        selectedDays.value = selectedDays.value.filter((selectedDay) => selectedDay !== day.value)
    }
    else {
        selectedDays.value.push(day.value)
    }
}


async function saveSettings() {
    isLoading.value = true

    let frequency = {}

    const workflow_id = route.params.workflow_id
    const startFrequency = selectedFrequency.value
    if (startFrequency === "ONCE_A_DAY") {
        frequency = {
            time_start: selectedTimeStart.value,
        }
    }
    else if (startFrequency === "MULTIPLY_TIMES_A_DAY") {
        frequency = {
            time_range_start: selectedTimeRange.value[0],
            time_range_end: selectedTimeRange.value[1],
            offset: selectedOffset.value,
        }
    }

    const workflowSettings = {
        "is_trigger_start_enabled": isEnabled.value,
        "start_frequency": selectedFrequency.value,
        "frequency": frequency,
        "days": selectedDays.value,
    }

    await Api.saveWorkflowSettings(workflow_id, workflowSettings)

    isLoading.value = false

    if (isVisible.value !== undefined) {
        isVisible.value = false
    }
}

</script>

<template>
    <div class="w-full flex flex-col items-center justify-center">
        <div class="flex mr-auto ml-10 my-4 items-center">
            <ToggleSwitch v-model:is-checked="isEnabled" />
            <div class="text-gray-600 ml-2 font-bold text-xs">Запускать автоматчиески</div>
        </div>
        <div class="mr-auto ml-10 mb-3 text-gray-600 font-bold">Частота выгрузки</div>
        <form class="flex flex-col gap-4 w-4/5 ml-10 mr-auto">
            <select
                id="frequency"
                class="bg-gray-50 border border-gray-500 hover:border-gray-700 outline-none
                       text-gray-900 text-sm rounded-sm block w-full py-4 px-4
                         appearance-none custom-arrow"
                :class="{'cursor-pointer': isEnabled}"
                :disabled="!isEnabled"
                v-model="selectedFrequency"
            >
                <option disabled>Частота выгрузки</option>
                <option
                    v-for="setting in frequencySettings"
                    v-bind:key="setting"
                    :value="setting.value"
                >
                    {{ setting.name }}
                </option>
            </select>
            <select
                    class="bg-gray-50 border border-gray-500 hover:border-gray-700 outline-none
                           text-gray-900 text-sm rounded-sm block w-full py-4 px-4
                             appearance-none custom-arrow"
                    :class="{'cursor-pointer': isEnabled}"
                    :disabled="!isEnabled"
                    v-if="selectedFrequency === frequencySettings[0].value"
                    v-model="selectedOffset"
            >
                <option
                    v-for="offset in offsets"
                    v-bind:key="offset"
                    v-bind:value="offset.value"
                >
                    {{ offset.name }}
                </option>
            </select>
            <select
                    class="bg-gray-50 border border-gray-500 hover:border-gray-700 outline-none
                           text-gray-900 text-sm rounded-sm block w-full py-4 px-4
                             appearance-none custom-arrow"
                    :class="{'cursor-pointer': isEnabled}"
                    :disabled="!isEnabled"
                    v-if="selectedFrequency === frequencySettings[1].value"
                    v-model="selectedTimeStart"
            >
                <option v-for="range in ranges" v-bind:key="range" :value="range.time_range_start">
                    С {{ range.time_range_start }} до {{ range.time_range_end }}
                </option>
            </select>
        </form>

        <div
            v-if="isEnabled"
            class="w-full h-20 flex items-center justify-center gap-2"
        >
            <div
                class="size-8 rounded-full font-bold flex items-center justify-center cursor-pointer select-none relative day"
                :class="{
                    'bg-blue-500 text-white': isDaySelected(day),
                    'bg-gray-400 text-white': !isDaySelected(day)
                }"
                v-for="day in days"
                v-bind:key="day"
                v-on:click="toggleDay(day)"
            >
                {{ day.name[0] }}
                <div class="absolute -bottom-5 text-black text-xs font-normal day-desc">
                    {{day.name}}
                </div>
            </div>
        </div>
        <div
            v-else
            class="w-full h-20 flex items-center justify-center gap-2"
        >
            <div
                class="size-8 rounded-full font-bold flex items-center justify-center select-none relative day"
                :class="{
                    'bg-gray-500 text-gray-200': isDaySelected(day),
                    'bg-gray-400 text-gray-100': !isDaySelected(day)
                }"
                v-for="day in days"
                v-bind:key="day"
            >
                {{ day.name[0] }}
                <div class="absolute -bottom-5 text-black text-xs font-normal day-desc">
                    {{day.name}}
                </div>
            </div>
        </div>

        <div class="mr-auto ml-10 mb-3" v-if="selectedFrequency === 'MULTIPLY_TIMES_A_DAY' && selectedOffset < 8">
            Промежуток времени: <span class="text-blue-500">{{ selectedTimeRange[0] }} - {{ selectedTimeRange[1] }}</span>
        </div>
        <div class="w-4/5" v-if="selectedFrequency === 'MULTIPLY_TIMES_A_DAY' && selectedOffset < 8">
            <vue-slider
                v-model="selectedTimeRange"
                :silent="false"
                :data="rangeHours"
                :adsorb="true"
                :marks="true"
                :hide-label="true"
                :disabled="!isEnabled"
            />
        </div>
        <div>
            Используемое количество тразнакций в месяц - {{transactionsPerMonth}}
        </div>

        <div class="w-full flex mt-10 mb-10">
            <div
                 v-on:click="saveSettings"
                 class="ml-auto mr-10 w-32 h-10 mb-5 flex items-center justify-center bg-blue-500 hover:bg-blue-600 transition-all duration-200 rounded-md font-bold text-white cursor-pointer"
            >
                <div v-if="!isLoading">
                    Сохранить
                </div>
                <div v-else>
                    <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>



.custom-arrow {
    background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%20stroke-width%3D%221.5%22%20stroke%3D%22currentColor%22%20class%3D%22size-6%20stroke-black%22%3E%0A%20%20%3Cpath%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20d%3D%22m19.5%208.25-7.5%207.5-7.5-7.5%22%20%2F%3E%0A%3C%2Fsvg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.7rem top 50%;
    background-size: 0.65rem auto;
}
.day-desc {
    visibility: hidden;
}
.day:hover .day-desc {
    visibility: visible;
}
</style>
